"use client";

// ============================================================
// CLUBHUB – Die Abschnitte der Beiträge
// ============================================================
// Vier Fragen an denselben Bestand, darum Register statt vier
// Einträge in der Leiste (wie die Buchhaltung im Agent):
//
//   Beitragsarten   was kostet die Mitgliedschaft?
//   Zuordnungen     wer zahlt was, und wo klafft eine Lücke?
//   SEPA-Mandate    von wem dürfen wir einziehen?
//   Beitragsläufe   was ist wann hinausgegangen?
//
// Am Register steht die Zahl, die Geld kostet, wenn niemand
// hinsieht: Lücken in den Zuordnungen, unvollständige Mandate,
// offene Entwürfe.
// ============================================================
import { RegisterLeiste } from "@/components/ui/register-leiste";

export function BeitraegeRegister({ luecken, maengel, entwuerfe }: { luecken: number; maengel: number; entwuerfe: number }) {
  return (
    <RegisterLeiste
      basis="/beitraege"
      register={[
        { schluessel: "", label: "Beitragsarten" },
        { schluessel: "zuordnungen", label: "Zuordnungen", zaehler: luecken },
        { schluessel: "mandate", label: "SEPA-Mandate", zaehler: maengel },
        { schluessel: "laeufe", label: "Beitragsläufe", zaehler: entwuerfe },
      ]}
    />
  );
}
